module.exports = __webpack_public_path__ + "img/i-taxons-admin.b7aab86d.svg";